<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Tensiomètre locatif</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/ss_tensiometre.PNG" class="img-fluid" />
        <div class="card-text row" *ngIf="!preview">
            <ng-container *ngIf="favorite.ad_city.loc_service_tensiometre.all.loc !== '-1' && favorite.ad_city.loc_service_tensiometre.all.loc !== ''">
                <div class="tensiometre text-center indicateur">
                    <label>Facilité à trouver une location</label>
                    <img src="https://www.locservice.fr/images/tensiometre/fleche{{ favorite.ad_city.loc_service_tensiometre.all.loc }}.png"/>
                </div>
                <div class="last tensiometre text-center indicateur">
                    <label>Budget des locataires</label>
                    <img src="https://www.locservice.fr/images/tensiometre/fleche{{ favorite.ad_city.loc_service_tensiometre.all.budget }}.png"/>
                </div>
                <br/>
                <div class="col-md-12">
                    <p style="font-size: 10px;margin-top:10px; margin-bottom: 0px; text-align: right;">
                        par <a target="_blank" href="https://www.locservice.fr/tensiometre/tensiometre-{{ favorite.ad_city.city_code }}.html">locservice.fr</a>
                    </p>
                </div>
            </ng-container>
            <p class="text-center no-data" *ngIf="favorite.ad_city.loc_service_tensiometre.all.loc == '-1' || favorite.ad_city.loc_service_tensiometre.all.loc == ''">
                Pas de données
            </p>
        </div>
    </div>
</div>
